import axios from 'axios';
import qs from "qs";

const coursesApi = axios.create({
    baseURL: URL_COURSES_API
});

coursesApi.interceptors.request.use(async (request) => {
    if (localStorage.getItem('token')){
        request.headers.Authorization = localStorage.getItem('token');
    }
    return request;
}, error => Promise.reject(error));
/*
axios.interceptors.request.use((request) => {
    request.headers.Authorization = localStorage.getItem('token');
    return request;
}, error => Promise.reject(error));
axios.interceptors.response.use(response => response, error =>
    Promise.reject(error),
);
*/
const getReportCourseSignInSheet = ({body}) => axios.post('reports/courseSignInSheet', qs.stringify(body));
const getCoursePeopleByIdCourse = ({ courseId }) => coursesApi.get(`courseAttendees/getCoursePeopleByIdCourse/${courseId}`);
const updateCompletedStatus = ({ data }) => coursesApi.put('courseAttendees/updateCompletedStatus', data);
const sendReportByIdCourse = ({ courseId }) => coursesApi.get(`courseAttendees/sendReportByIdCourse/${courseId}`);


const sendEmailCompletion = ({body}) => coursesApi.post('course/sendEmailCompletion', qs.stringify(body));
const getCompletionAndSeatData =({courseId}) => coursesApi.get(`course/${courseId}/getCompletionAndSeatData`);
const getUsersInCourse = ({courseId, page, perPage, search}) => coursesApi.get(`course/${courseId}/getUsersInCourse`, {
    params: {
        page: page,
        perPage: perPage,
        search: search
    }
});
const getConfigurationInCourse = ({courseId}) => coursesApi.get(`course/${courseId}/getConfigurationInCourse`);
const changeStatusUsers = ({body}) => coursesApi.post('course/changeStatusUsers', qs.stringify(body));
const listPeople = ({body}) => coursesApi.post('reports/getAllUsers', qs.stringify(body, { arrayFormat: 'brackets' }));

const getUsersInvated = ({body}) => coursesApi.post('course/getInvatedUsersInCourse', qs.stringify(body));
const deleteUserInvated = ({body}) => coursesApi.post('course/deleteUserInvated', qs.stringify(body));


export default {
    getReportCourseSignInSheet,
    getCoursePeopleByIdCourse,
    updateCompletedStatus,
    sendReportByIdCourse,
    sendEmailCompletion,
    getCompletionAndSeatData,
    getUsersInCourse,
    getConfigurationInCourse,
    changeStatusUsers,
    listPeople,
    getUsersInvated,
    deleteUserInvated
};
